import { TemplateResult, html, CSSResultGroup } from 'lit';
import { property } from 'lit/decorators.js';
import { BlocksElement } from '../BlocksElement';
import type { DividerSize, DividerVariant } from './divider.model';
import styles from './divider.styles';

/**
 * Divider component
 * @csspart base - The component's base wrapper.
 */
export class BlocksDivider extends BlocksElement {static styles: CSSResultGroup = styles;

  /**
   * Style size
   * <cat-text-passage size="sm">
   * <ul>
   * <li> **md** applies a 2px `divider`</li>
   * <li> **lg** applies a 4px `divider`</li>
   * </ul>
   * </cat-text-passage>
   */
  @property({ type: String })
  size: DividerSize;

  /**
   * Background size
   * <cat-text-passage size="sm">
   * <ul>
   * <li> **brand** applies the brand background color</li>
   * </ul>
   * </cat-text-passage>
   */
  @property({ type: String })
  background: DividerVariant;

  render(): TemplateResult<1> {
    const componentClassNames = this.componentClassNames('cat-c-divider', {
      'cat-c-divider--md': this.size === 'md',
      'cat-c-divider--lg': this.size === 'lg',
      'cat-c-divider--brand': this.background === 'brand'
    });

    return html` <hr part="base" class="${componentClassNames}" /> `;
  }
}

if (customElements.get('cat-divider') === undefined) {
  customElements.define('cat-divider', BlocksDivider);
}

declare global {
  interface HTMLElementTagNameMap {
    'cat-divider': BlocksDivider;
  }
}
